import { isDnf } from "../DriverTime";
import { RoundTime } from "../Track/RoundTime";

const DEFAULT_POINTS = 0;

export type PointsDistribution = {
  distribution: number[];
  dnfPoints: number | undefined;
};

export const getPoints = (
  { distribution, dnfPoints }: PointsDistribution,
  time: RoundTime
) => {
  if (isDnf(time) && dnfPoints !== undefined) {
    return dnfPoints;
  }

  if (time.position > distribution.length) {
    return distribution.at(-1) ?? DEFAULT_POINTS;
  }

  return distribution.at(time.position - 1) ?? DEFAULT_POINTS;
};

export const getDefaultPointsDistribution = (
  numDrivers: number
): PointsDistribution => {
  const distribution: number[] = [];
  for (let i = numDrivers; i > 0; i--) {
    distribution.push(i);
  }

  return {
    distribution,
    dnfPoints: 0,
  };
};
